export const SKIP_FIELDS = ['clinicId', 'id', 'createdAt', 'modifiedAt'];

export const SERVICE_LABELS = {
    reminder: 'Appointment Reminders',
    recall: 'Patient Recalls',
    reputation: 'Reputation Management',
    survey: 'Patient Surveys',
    surveyReminder: 'Survey Reminders',
    booking: 'Online Booking',
    twoWayText: 'Two-way Text Messaging',
    isAntispamLaw: 'Anti-Spam Compliance',
    reminderEmail: 'Email Reminders',
    reminderCall: 'Phone Reminders',
    reminderSms: 'SMS Reminders',
    newsletterEmail: 'Email Newsletter',
    newsletterSms: 'SMS Newsletter',
    blastEmail: 'Email Blasts',
    blastSms: 'SMS Blasts',
    blastCall: 'Call Campaigns',
};

export const SERVICE_GROUPS = [
    {
        title: 'Core Features',
        keys: ['reminder', 'recall', 'reputation', 'survey', 'booking', 'twoWayText', 'isAntispamLaw'],
    },
    {
        title: 'Reminder Channels',
        keys: ['reminderEmail', 'reminderCall', 'reminderSms'],
    },
    {
        title: 'Newsletter',
        keys: ['newsletterEmail', 'newsletterSms'],
    },
    {
        title: 'Blast Campaigns',
        keys: ['blastEmail', 'blastSms', 'blastCall'],
    },
    {
        title: 'Survey',
        keys: ['surveyReminder'],
    },
];

export const getServiceLabel = (key) => SERVICE_LABELS[key] || key;

export const getServiceIconClass = (key) => {
    switch (key) {
        case 'reminder':
        case 'reminderEmail':
        case 'reminderCall':
        case 'reminderSms':
            return 'bi-bell';
        case 'recall':
            return 'bi-calendar-check';
        case 'reputation':
            return 'bi-star';
        case 'survey':
        case 'surveyReminder':
            return 'bi-clipboard-check';
        case 'booking':
            return 'bi-bookmark-check';
        case 'twoWayText':
            return 'bi-chat-left-text';
        case 'isAntispamLaw':
            return 'bi-shield-lock';
        case 'newsletterEmail':
        case 'newsletterSms':
            return 'bi-envelope';
        case 'blastEmail':
        case 'blastSms':
        case 'blastCall':
            return 'bi-megaphone';
        default:
            return 'bi-gear';
    }
};

export const getServiceIconTone = (key) => {
    switch (key) {
        case 'reminder':
        case 'reminderEmail':
        case 'reminderCall':
        case 'reminderSms':
            return 'reminder';
        case 'recall':
            return 'recall';
        case 'reputation':
            return 'reputation';
        case 'survey':
        case 'surveyReminder':
            return 'survey';
        case 'booking':
            return 'booking';
        case 'twoWayText':
            return 'messaging';
        case 'isAntispamLaw':
            return 'compliance';
        case 'newsletterEmail':
        case 'newsletterSms':
            return 'newsletter';
        case 'blastEmail':
        case 'blastSms':
        case 'blastCall':
            return 'blast';
        default:
            return 'default';
    }
};

export const getServiceEntries = (settings) => {
    if (!settings || typeof settings !== 'object') return [];

    const groupedKeys = new Set(SERVICE_GROUPS.flatMap((g) => g.keys));
    const entries = [];

    SERVICE_GROUPS.forEach((group) => {
        const items = group.keys
            .filter((key) => key in settings && !SKIP_FIELDS.includes(key))
            .map((key) => ({ key, value: settings[key], group: group.title }));

        if (items.length > 0) {
            entries.push({ title: group.title, items });
        }
    });

    const otherItems = Object.entries(settings)
        .filter(([key]) => !SKIP_FIELDS.includes(key) && !groupedKeys.has(key))
        .map(([key, value]) => ({ key, value, group: 'Other' }));

    if (otherItems.length > 0) {
        entries.push({ title: 'Other', items: otherItems });
    }

    return entries;
};

export const countEnabledServices = (settings) => {
    if (!settings) return { enabled: 0, disabled: 0, total: 0 };

    const serviceEntries = Object.entries(settings).filter(([key]) => !SKIP_FIELDS.includes(key));
    const enabled = serviceEntries.filter(([, value]) => value === true).length;

    return {
        enabled,
        disabled: serviceEntries.length - enabled,
        total: serviceEntries.length,
    };
};
